var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneCheckSignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F83DD",
    fillRule: "nonzero",
    d: "M39.415 28.814l-2.465-2.432c-8.336-8.226-21.763-8.136-29.989.2-8.226 8.337-8.136 21.763.2 29.99L24.521 73.7c8.257 8.149 21.53 8.149 29.788 0L91.35 37.15c8.337-8.226 8.426-21.652.2-29.989-8.226-8.336-21.652-8.426-29.989-.2L39.415 28.814z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.956 9.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 68.85,
    stroke: "#0F0238",
    strokeWidth: 3.4,
    rx: 2.55,
    transform: "matrix(-1 0 0 1 40.8 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4,
    cy: 58.225,
    r: 3.4,
    fill: "#0F0238"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0F0238",
    strokeWidth: 3.4,
    d: "M25.5 8.075H15.3h10.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-66-19h231v119H-66z"
  }))));
}

export default SvgPhoneCheckSignIcon;